<template>
  <div class="md:ml-12 max-w-600 my-8 mb-12">
    <div class="label">
      <img src="./assets/oral-icon.svg" alt="" />
      <span class="px-2">口述题</span>
    </div>
    <div class="mb-4">
      <h1 class="font-normal title-text text-lg whitespace-pre-wrap">
        <span>{{ content.title.trim() }}</span>
      </h1>
    </div>

    <div class="content-wrap w-full px-4 py-4">
      <Transition name="fade" mode="out-in">
        <div v-if="fileUrl" class="w-full">
          <AudioRecordPlayer class="mb-3" :fileUrl="fileUrl" />
          <div class="flex justify-center w-full">
            <div
              class="flex justify-center items-center margin-auto cursor-pointer retry-btn"
              @click="handleReRecord"
            >
              重新录音
            </div>
          </div>
        </div>
        <AudioRecord
          v-else
          :isReRecord="isReRecord"
          :title="content.title"
          @file-change="handleFileChange"
        />
      </Transition>
    </div>
  </div>
</template>
<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';
import AudioRecord from './AudioRecord.vue';
import AudioRecordPlayer from './AudioRecordPlayer.vue';

@Component({
  components: {
    AudioRecord,
    AudioRecordPlayer
  }
})
export default class Oral extends Vue {
  @Prop({ type: Object }) content!: Content & { title: string; fileUrl: string };
  isRecording = false;
  fileUrl = '';
  isReRecord = false;

  handleFileChange(url: string) {
    this.fileUrl = url;
    if (url) {
      window.storyteller.updateAssignContent({
        $id: this.content.$id,
        $kind: this.content.$kind,
        ...{
          fileUrl: url
        }
      });
    }
  }

  handleReRecord() {
    this.isReRecord = true;
    this.fileUrl = '';
  }

  mounted() {
    this.fileUrl = this.content.fileUrl;
  }
}
</script>

<style lang="scss" scoped>
.label {
  @apply mb-4 flex text-motif-500;
}
.content-wrap {
  border: 1px solid #d3d3d3;
  border-radius: 8px;
}
.retry-btn {
  top: 827px;
  left: 385px;
  width: 84px;
  height: 32px;
  color: #1a051d;
  background: #ffffff;
  border: 1.2px solid #c2c2c2;
  border-radius: 4px;
  &:hover {
    color: #433eff;
    border-color: #433eff;
  }
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s linear;
}
</style>
